import {EventEmitter} from "nate-react-api-helpers";

// fires with a purchase order id when its item list changes, so views showing
// PO-level roll-ups (linked projects, linked bills) can refresh themselves
export const purchaseOrderItemsChanged = new EventEmitter<number>("purchasing.items-changed");
